import dayjs from "dayjs";

export function getDateRange(value: number) {
  const now = new Date(); // Use the local current time based on the user's time zone
  let startDate: Date, endDate: Date;

  switch (value) {
    case 1: // Last 3 hours
      startDate = new Date(now.getTime() - 3 * 3600 * 1000);
      endDate = new Date(now);
      break;
    case 2: // Last 6 hours
      startDate = new Date(now.getTime() - 6 * 3600 * 1000);
      endDate = new Date(now);
      break;
    case 3: // Just for Today
      startDate = new Date(now);
      endDate = new Date(now);
      startDate.setHours(0, 0, 0, 0); // Start of today in user's timezone
      endDate.setHours(23, 59, 59, 999); // End of today in user's timezone
      break;
    case 4: // From Yesterday
      startDate = new Date(now);
      endDate = new Date(now);
      // Set startDate to the start of yesterday
      startDate.setDate(now.getDate() - 1);
      startDate.setHours(0, 0, 0, 0); // Start of yesterday in user's timezone
      // Set endDate to the end of today
      endDate.setHours(23, 59, 59, 999); // End of today in user's timezone
      break;
    case 5: // Last 7 days
      startDate = new Date(now);
      endDate = new Date(now);
      startDate.setDate(now.getDate() - 6);
      startDate.setHours(0, 0, 0, 0); // Start of 7 days ago in user's timezone
      endDate.setHours(23, 59, 59, 999); // End of today in user's timezone
      break;
    case 6: // Last 15 days
      startDate = new Date(now);
      endDate = new Date(now);
      startDate.setDate(now.getDate() - 14);
      startDate.setHours(0, 0, 0, 0); // Start of 15 days ago in user's timezone
      endDate.setHours(23, 59, 59, 999); // End of today in user's timezone
      break;
    case 7: // Last 3 months
      startDate = new Date(now);
      endDate = new Date(now);
      startDate.setMonth(now.getMonth() - 3);
      startDate.setHours(0, 0, 0, 0); // Start of 3 months ago in user's timezone
      endDate.setHours(23, 59, 59, 999); // End of today in user's timezone
      break;
    default:
      throw new Error("Invalid date range value");
  }

  // Convert the start and end dates to UTC strings
  return {
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  };
}

export function getCustomDateRange(start: Date, end: Date) {
  const startDate = new Date(start);
  let endDate = new Date(end);
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(23, 59, 59, 999);

  return {
    FROM_DATE: startDate.toISOString(),
    TO_DATE: endDate.toISOString(),
  };
}

export function getDateRangeFromReference(from?: Date | string, days = 15): { minDate: Date; maxDate: Date } {
  const fallbackMin = dayjs("1970-01-01").startOf("day");
  const fallbackMax = dayjs().endOf("day");

  const fromDate = from ? dayjs(from) : null;

  // Invalid or missing date → fallback
  if (!fromDate?.isValid()) {
    return {
      minDate: fallbackMin.toDate(),
      maxDate: fallbackMax.toDate(),
    };
  }

  const minDate = fromDate.startOf("day");

  // ✅ inclusive range → subtract 1 day
  const maxDate = fromDate.add(days - 1, "day").endOf("day");

  return {
    minDate: minDate.toDate(),
    maxDate: maxDate.toDate(),
  };
}

export const today = dayjs().endOf("day").toDate();

export function isMoreThanNDaysOld(dateInput: string | Date, days = 15): boolean {
  const inputDate = new Date(dateInput);
  const now = new Date();

  const diffInMs = now.getTime() - inputDate.getTime();
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

  return diffInDays > days;
}
